import { Image } from 'component/Image'
import { Typo } from 'component/Typo/Typo'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { comboCartStore } from 'page/catalog/store/ComboCartStore'
import { useEffect, useState } from 'react'
import { Item } from 'type/Item'
import { ItemPlaceholder } from './ItemPlaceholder'
import css from './SelectedItems.module.scss'

const Separator = () => {
  return <span className={css.separator}>+</span>
}

function getName(item: Item, show_name: boolean, top: boolean) {
  const { product_name } = item
  const name = show_name ? product_name : ''
  return name || (top ? i18n('DressShapeTop') : i18n('DressShapeBottom'))
}

export const SelectedItems = observer(() => {
  const { show_name } = useDemo()
  const [isClient, setIsClient] = useState(false)
  const { selectedTopItem, selectedBottomItem } = comboCartStore

  useEffect(() => {
    setIsClient(true)
  }, [])

  if (!isClient) {
    return (
      <div className={css.currentItems}>
        <ItemPlaceholder text={i18n('combo.Item1')} />
        <Separator />
        <ItemPlaceholder text={i18n('combo.Item2')} />
      </div>
    )
  }

  return (
    <div className={css.currentItems}>
      {selectedTopItem ? (
        <div className={css.selectedItem}>
          <Image
            src={selectedTopItem.images?.[0]}
            className={css.itemImage}
          />
          <Typo ellipsis size={11}>
            {getName(selectedTopItem, show_name, true)}
          </Typo>
        </div>
      ) : (
        <ItemPlaceholder text={i18n('combo.Item1')} />
      )}

      <Separator />

      {selectedBottomItem ? (
        <div className={css.selectedItem}>
          <Image
            src={selectedBottomItem.images?.[0]}
            className={css.itemImage}
          />
          <Typo ellipsis size={11}>
            {getName(selectedBottomItem, show_name, false)}
          </Typo>
        </div>
      ) : (
        <ItemPlaceholder text={i18n('combo.Item2')} />
      )}
    </div>
  )
})
